export enum OrgLevelTypeEnum {
    Other = 0,
    Site = 1,
    Department = 2,
    Function = 4,
    BusinessUnit = 5,
    Corporate = 6,
}